import ko from './messages/ko/common.json';
import en from './messages/en/common.json';
import koFooter from './messages/ko/footer.json';
import enFooter from './messages/en/footer.json';
import koHome from './messages/ko/home.json';
import enHome from './messages/en/home.json';
import koProduct from './messages/ko/product.json';
import enProduct from './messages/en/product.json';
import koOrder from './messages/ko/order.json';
import enOrder from './messages/en/order.json';
import koRefund from './messages/ko/refund.json';
import enRefund from './messages/en/refund.json';
import koServer from './messages/ko/server.json';
import enServer from './messages/en/server.json';
import koCorrect from './messages/ko/correct.json';
import enCorrect from './messages/en/correct.json';
import koCorrectFile from './messages/ko/correctFile.json';
import enCorrectFile from './messages/en/correctFile.json';
import koSpeller from './messages/ko/speller.json';
import enSpeller from './messages/en/speller.json';
import koAnalyze from './messages/ko/analyze.json';
import enAnalyze from './messages/en/analyze.json';
import koTokenize from './messages/ko/tokenize.json';
import enTokenize from './messages/en/tokenize.json';
import koTryCommon from './messages/ko/tryCommon.json';
import enTryCommon from './messages/en/tryCommon.json';
import type { Locale } from './config';

/**
 * 문자열 파일은 `messages/<언어>/<화면>.json`. 화면 단위로 파일을 늘린다.
 * 영어에 없는 키는 한국어로 대체해 화면이 비지 않게 한다(번역 누락은 messages.test.ts 가 보고한다).
 * 화면이 늘면 NAMESPACES 에 더한다.
 */
export const NAMESPACES = {
  common: { ko, en },
  footer: { ko: koFooter, en: enFooter },
  home: { ko: koHome, en: enHome },
  product: { ko: koProduct, en: enProduct },
  order: { ko: koOrder, en: enOrder },
  refund: { ko: koRefund, en: enRefund },
  server: { ko: koServer, en: enServer },
  correct: { ko: koCorrect, en: enCorrect },
  correctFile: { ko: koCorrectFile, en: enCorrectFile },
  speller: { ko: koSpeller, en: enSpeller },
  analyze: { ko: koAnalyze, en: enAnalyze },
  tokenize: { ko: koTokenize, en: enTokenize },
  tryCommon: { ko: koTryCommon, en: enTryCommon }
} as const;
export type Namespace = keyof typeof NAMESPACES;

type Dict = { [k: string]: string | Dict };

function lookup(dict: Dict, key: string): string | undefined {
  let cur: string | Dict | undefined = dict;
  for (const part of key.split('.')) {
    if (cur === undefined || typeof cur === 'string') return undefined;
    cur = cur[part];
  }
  return typeof cur === 'string' ? cur : undefined;
}

export function createT(locale: Locale, ns: Namespace) {
  const set = NAMESPACES[ns] as unknown as Record<Locale, Dict>;
  return (key: string, params?: Record<string, string | number>): string => {
    const raw = lookup(set[locale], key) ?? lookup(set.ko, key) ?? key;
    return params
      ? raw.replace(/\{(\w+)\}/g, (_, k) => String(params[k] ?? `{${k}}`))
      : raw;
  };
}
